import { createContext } from "react";

/**
 * Куда выносится ряд действий над сообщением — слой поверх ленты, а не сама
 * лента.
 *
 * Ряд в v6 — стеклянные капли, а стекло размывает то, что под ним. Внутри
 * ленты этого не выходит: у ленты маска (край растворяется под шапкой и
 * полем ввода), а маска отрезает всё, что внутри неё, от того, что снаружи, —
 * стекло видело бы только строки и не видело фон. Поэтому ряд рисуется в
 * слое рядом с лентой и сам ходит за своей строкой.
 *
 * Нет слоя (панель веток) — ряд остаётся внутри строки, как раньше.
 */
export const ToolbarHost = createContext<HTMLElement | null>(null);
